module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/point03_01_spectacular_spot-bd401da3b654f14f7dd127832547dc3f.jpg";